<template>
  <div class="team-sign-in flex-col w-100p">
    <div
      class="mx-1 text-left mw-64"
      v-if="isTeamEnter"
    >
      <h1 v-if="isCaptain">Команда мечты!</h1>
      <h1 v-else>Проходим, проходим!</h1>

      <div v-if="isCaptain">
        <p
          v-if="hasTeams"
        >Выберите команду из списка, или создайте новую:</p>

        <p
          v-else
        >Создайте свою команду:</p>
      </div>

      <ul
        class="teamlist"
        v-show="hasTeams"
        v-if="isCaptain"
      >
        <li
          v-for="team in teamListSlice"
          v-bind:key="team.selector"
        >
          <button
            class="teamlist__item"
            v-bind:class="{ active: team.selector === selectedTeam }"
            v-on:click="selectTeam(team)"
          >{{ team.name }}</button>
        </li>

        <li
          v-if="hasMoreTeams"
        >
          <a
            href="#"
            class="button inactive"
            v-on:click.prevent="setTeamSelect"
          >Ещё {{ moreTeamsLabel }}</a>
        </li>
      </ul>

      <div
        v-if="isCaptain"
        class="middle-wrap text-center mt2"
      >
        <button
          class="button dark"
          v-bind:class="{ faded: isTeamSelected }"
          v-on:click="setTeamRegister"
        >Создать новую команду</button>
      </div>

      <div class="middle-wrap mt2">
        <div class="form-group">
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              name="user_type"
              value="captain"
              id="user_type__captain"
              v-model="userType"
            />
            <label for="user_type__captain">
              Я капитан!
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              name="user_type"
              value="player"
              id="user_type__player"
              v-model="userType"
            />
            <label for="user_type__player">
              Я просто посмотреть
            </label>
          </div>
        </div>
        <div class="hint mt2">
          Внимание! Только капитан будет иметь возможность
          возможность заполнять бланк с ответами!
        </div>
      </div>

      <div class="form__controls text-center">
        <button
          class="button dark"
          v-bind:class="{ inactive: !allowedSendForm }"
          v-on:click="sendForm"
        >
          Готово
        </button>
      </div>
    </div>

    <div
      v-if="isTeamSelect"
      class="team__select text-left mw-64 mx-1"
    >
      <div class="form__fields">
        <button
          class="button button-icon button-icon-full"
          v-on:click="setTeamEnter"
        >
          <i class="icon icon__back"></i>
        </button>

        <h1>Список команд</h1>

        <p>Выберите команду, за которую хотите играть:</p>

        <div class="scroll__wrapper">
          <scroll-box
            v-bind:options="teamList"
            v-on:select="useTeam"
          />
        </div>
      </div>
    </div>

    <div
      v-if="isTeamRegister"
      class="team__register text-left mw-64 mx-1"
    >
      <div class="form__fields">
        <button
          class="button button-icon button-icon-full"
          v-on:click="setTeamEnter"
        >
          <i class="icon icon__back"></i>
        </button>

        <h1>Создай команду мечты!</h1>

        <p>
          Придумайте и укажите название своей команды.
          <br>
          Будьте оригинальными!
        </p>

        <div class="form-input__wrapper">
          <input
            type="text"
            class="form-input"
            placeholder="Игра Финчера"
            v-model.trim="form.teamName"
          />
        </div>

        <div class="hint">
          Каламбуры и реплики &ndash; одно из работающих решений
          в создании хорошего названия команды.
          <br><br>
          &laquo;Могучая взбучка&raquo; или &laquo;Ах так?!&raquo; явно обратят на себя внимание!
        </div>
      </div>

      <div class="form__controls text-center">
        <span
          class="ajax-loading"
          v-if="isLoading"
        ></span>
        <button
          class="button dark"
          v-on:click="registerTeam"
          v-else
        >
          Готово
        </button>
      </div>
    </div>

    <form
      v-if="false"
      class="form"
      action=""
      v-on:submit.prevent="sendForm"
    >
      <div class="input-field" v-if="isCaptain">
        <p
          class="input-field__description"
          v-if="hasTeams"
        >
          Выберите команду
        </p>
        <p
          class="input-field__description"
          v-else
        >
          Cоздайте команду
        </p>

        <div class="team-list-wrapper">
          <div class="team-list">
            <div
              class="team-list__item"
              v-for="team in teamList"
              v-bind:class="{ selected: team.selector === selectedTeam }"
              v-bind:key="team.selector"
              v-on:click="selectTeam(team)"
            >
              {{ team.name }}
            </div>
          </div>
        </div>

        <p
          class="input-field__description input-field__description-rev"
          v-if="hasTeams"
        >
          или создайте новую
        </p>

        <input
          type="text"
          class="form-input"
          name="teamName"
          placeholder="название команды"
          v-model.trim="form.teamName"
          v-bind:required="isCaptain && !selectedTeam"
          v-on:input="selectedTeam = ''"
          v-focus
        />
      </div>

      <!-- <div class="input-field" v-if="!hideCity">
        <input
          type="text"
          class="form-input"
          name="teamCity"
          placeholder="город"
          v-model.trim="form.teamCity"
          required
        />
      </div> -->

      <div class="input-field input-field__checkgroup">
        <input
          type="radio"
          id="user-type__captain"
          name="user_type"
          value="captain"
          v-model="userType"
        >
        <label for="user-type__captain">Я капитан</label>

        <input
          type="radio"
          id="user-type__player"
          name="user_type"
          value="player"
          v-model="userType"
        >
        <label for="user-type__player">Я просто посмотреть</label>
      </div>

      <div class="form-controls">
        <button
          class="dark button"
          v-bind:disabled="isLoading"
        >
          Играть!
        </button>
      </div>
    </form>
  </div>
</template>

<script>
/* global window */

// import Storage from '../../../lib/Storage';
import Api from '../../../lib/PlayerApi';
import Auth from '../../../lib/Auth';
import Toast from '../../../lib/ToastWrapper';
import ScrollBox from '../../shared/ScrollBox.vue';

const UserTypes = Object.freeze({
  Captain: 'captain',
  Player: 'player',
});

const ErrorMessages = Object.freeze({
  common: 'Ошибка при создании команды',
  name_not_allowed: 'Такая команда уже существует',
  should_select_team: 'Нужно выбрать команду или создать новую',
});

const States = Object.freeze({
  teamEnter: 'TEAM_ENTER',
  teamSelect: 'TEAM_SELECT',
  teamRegister: 'TEAM_REGISTER',
});

const plural = (number, titles) => {
  // 0 - single, 1 - two..four, 2 - five
  const cases = [2, 0, 1, 1, 1, 2];
  const pos4 = (number % 100 > 4 && number % 100 < 20);
  const pos5 = (number % 10 < 5) ? number % 10 : 5;
  return titles[pos4 ? 2 : cases[pos5]];
};

const MAX_SHOWN_TEAMS = 3;

export default {
  name: 'TeamSignIn',

  props: {
    data: Object,

    meta: {
      type: Object,
      required: true,
    },
  },

  components: {
    ScrollBox,
  },

  data() {
    return {
      teamList: [],

      form: {
        teamName: '',
        teamCity: '',
        action: 'signin',
      },

      selectedTeam: '',

      userType: UserTypes.Captain,
      isLoading: false,

      currentState: States.teamEnter,
    };
  },

  mounted() {
    this.fetchTeamList();

    // try to read from storage
    // try {
    //   const json = Storage.get('player');

    //   if (json) {
    //     const player = JSON.parse(json);

    //     this.form.teamName = player.teamName;
    //     this.form.teamCity = player.teamCity;
    //   }
    // } catch { /* assume that there's no stored value */ }
  },

  computed: {
    isTeamEnter() {
      return this.currentState === States.teamEnter;
    },

    isTeamSelect() {
      return this.currentState === States.teamSelect;
    },

    isTeamRegister() {
      return this.currentState === States.teamRegister;
    },

    hideCity() {
      return this.meta && this.meta.no_city;
    },

    hasTeams() {
      return this.teamList.length > 0;
    },

    isCaptain() {
      return this.userType === UserTypes.Captain;
    },

    isTeamSelected() {
      return !!this.selectedTeam;
    },

    teamListSlice() {
      return this.teamList.slice(0, MAX_SHOWN_TEAMS);
    },

    moreTeamCount() {
      return this.teamList.length - MAX_SHOWN_TEAMS;
    },

    moreTeamsLabel() {
      const label = plural(this.moreTeamCount, ['команда', 'команды', 'команд']);
      return `${this.moreTeamCount} ${label}`;
    },

    hasMoreTeams() {
      return this.moreTeamCount > 0;
    },

    allowedSendForm() {
      return !this.isCaptain || this.isTeamSelected;
    },
  },

  methods: {
    setTeamSelect() {
      this.currentState = States.teamSelect;
    },

    setTeamEnter() {
      this.currentState = States.teamEnter;
    },

    setTeamRegister() {
      this.currentState = States.teamRegister;
    },

    useTeam(selector) {
      const idx = this.teamList.findIndex(x => x.selector === selector);

      if (idx >= MAX_SHOWN_TEAMS) {
        const items = this.teamList.splice(idx, 1);
        this.teamList.unshift(items[0]);
      }

      this.selectedTeam = selector;

      this.setTeamEnter();
    },

    selectTeam({ selector }) {
      this.selectedTeam = selector;
    },

    sendForm() {
      if (this.isCaptain && !this.isTeamSelected) {
        Toast.show(ErrorMessages.should_select_team);
        return;
      }

      if (!this.isCaptain) {
        this.$emit('sendForm', { isCaptain: false, action: 'signin' });
      } else {
        if (!this.selectedTeam) {
          Toast.show('Что-то пошло не так...');
          return;
        }

        const team = this.teamList.find(x => x.selector === this.selectedTeam);
        this.$emit('sendForm', {
          isCaptain: true,
          teamName: team.name,
          teamSelector: this.selectedTeam,
          action: 'signin',
        });
      }
    },

    fetchTeamList() {
      Api.teams.list()
        .then((data) => {
          this.teamList = data;
        })
        .catch((err) => {
          if (err.data && err.data.code === 401) {
            // should remove token and reload page
            Auth.removeAuth();
            window.location.reload();
          }

          console.warn('Failed to fetch team list', err);
        });
    },

    registerTeam() {
      if (this.form.teamName.length <= 0) {
        Toast.show('Укажите название команды');
        return;
      }

      this.isLoading = true;

      Api.teams
        .create({ team_name: this.form.teamName })
        .then((team) => {
          this.form.teamName = '';

          this.teamList.unshift(team);
          this.selectedTeam = team.selector;
          this.setTeamEnter();
        })
        .catch((err) => {
          const { data } = err;
          let errCode = data && data.data && data.data.error;

          if (!ErrorMessages[errCode]) {
            errCode = 'common';
          }

          Toast.show(ErrorMessages[errCode]);
          console.warn('Failed to create team', err);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
